import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Github,XIcon,LinkedinIcon,X, Mail, Heart } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const Footer = ({ onNavigate }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const NavLink = ({ label, view }) => (
    <button
      onClick={() => {
        if (['dashboard','management','triage'].includes(view) && !isAuthenticated) {
          navigate('/login', { state: { fromView: view } });
        } else {
          onNavigate && onNavigate(view);
        }
      }}
      className="text-sm text-gray-600 hover:text-cyan-700 transition-colors"
    >
      {label}
    </button>
  );

  return (
    <footer  className="grid h-48 grid-cols-3 justify-between place-content-stretch gap-4 mt-12 flex flex-col items-center border-t border-gray-200 bg-white/70 backdrop-blur sticky top-[100vh]">
      {/* <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row place-content-baseline items-center justify-between gap-3"> */}
        
        {/* <div class="grid h-48 grid-cols-3 justify-between place-content-center gap-">  */}
          
           {/* <div> */}
        <div className="flex flex-col items-center gap-4 text-gray-500 text-sm">
          <span className="hidden sm:inline">TriageOS</span>
          <span className="hidden sm:inline">•</span>
          <span className="flex items-center gap-1">
            <Heart className="w-4 h-4 text-rose-500" />
            <span>Built for circularity</span>
          </span>
        </div>
           {/* </div>   */}

           {/* <div> */}
        <nav className="flex flex flex-col items-center gap-4">
          <NavLink label="Home" view="landing" />
          <NavLink label="About" view="about" />
          <NavLink label="Dashboard" view="dashboard" />
          <NavLink label="Asset Manager" view="management" />
        </nav>
           {/* </div>   */}

        <div className="flex items-center flex flex-col items-center gap-4 text-gray-500">
          {/* <a href="https://github.com/" target="_blank" rel="noreferrer" className="hover:text-gray-700" aria-label="GitHub">
            <Github className="w-5 h-5" />
            <span className="hidden sm:inline">Github</span>
          </a> */}
            <a href="https://github.com/" className="hover:text-gray-700 flex items-center gap-1 text-sm" aria-label="Contact">
            <Github className="w-5 h-5" />
            {/* <span className="hidden sm:inline">Github</span> */}
          </a>
            <a href="https://x.com/" className="hover:text-gray-700 flex items-center gap-1 text-sm" aria-label="Contact">
            <X className="w-5 h-5" />
            {/* <span className="hidden sm:inline">X</span> */}
          </a>
            <a href="https://www.linkedin.com/" className="hover:text-gray-700 flex items-center gap-1 text-sm" aria-label="Contact">
            <LinkedinIcon className="w-5 h-5" />
            {/* <span className="hidden sm:inline">LinkedIn</span> */}
          </a>
          <a href="mailto:contact@example.com" className="hover:text-gray-700 flex items-center gap-1 text-sm" aria-label="Contact">
            <Mail className="w-5 h-5" />
            <span className="hidden sm:inline">Contact</span>
          </a>
        </div>

        {/* </div> */}

      {/* </div> */}
    </footer>
  );
};

export default Footer;
